// removed by extract-text-webpack-plugin
module.exports = {"bp-tablet":"(max-width: 1200px)","sectionWrapper":"src-layouts----app-module---sectionWrapper---33Nem"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/app.module.css
// module id = 9
// module chunks = 35783957827783 40078938568781 114276838955818